<template>
  <div class="container">
    <van-dialog
      class="dialog"
      v-model="Showsecond"
      title="IOS安装说明"
      show-cancel-button
    >
      <div class="container__dialog">
        <p class="container__dialog__p">1. 如何快速安装ios客户端?</p>
        <span class="container__dialog_span">
          点击【立即下载】将会跳转【itunes store】 自动下载APP。
        </span>
        <p class="container__dialog__p">
          2. 跳转【itunes store】需要输入密码的情况
        </p>
        <span class="container__dialog_span">
          输入AppleID对应的密码，即可完成下载。
        </span>
        <p class="container__dialog__p">3. 没有安装【itunes store】怎么办？</p>
        <span class="container__dialog_span">
          打开手机本地的【App Store】, 下载安装【itunes store】,
          安装完成后回到本页面,点击【立即下载】, 将跳转【itunes
          store】自动下载APP。
        </span>
        <div class="container__dialog__button">
          <van-button
            round
            type="info"
            class="container__dialog__button__confirm"
            @click="Downloadnow()"
            >立即下载</van-button
          >
          <van-button
            color="#eeeeee"
            round
            class="container__dialog__button__signout"
            @click="Donotdownload()"
            >暂不下载</van-button
          >
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: "IOSopen",
  props: {},
  data() {
    return {
      Showsecond: false,
    };
  },
  methods: {
    openPopup() {
      this.Show = true;
    },
    Donotdownload() {
      this.Show = false;
    },
    Downloadnow() {
      console.log("点击立即下载了");
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.container {
  text-align: center;
  .dialog {
    height: 13rem;
    width: 70%;
    // padding: 0.1rem 2em ;
    box-sizing: border-box;
  }
  .container__dialog {
    width: 100%;
    height: 8.6rem;
    // padding: 0.2rem 0 ;
    text-align: left;
    .container__dialog__p {
      padding: 0 3em;
      // text-indent: 2em;
      text-align: center;
      line-height: 0.5rem;
      text-align: left;
      font-size: 0.25rem;
      color: #007aff;
    }

    .container__dialog_span {
      text-align: center;
      display: inline-block;
      padding-left: 4em;
      padding-right: 3em;
      line-height: 0.5rem;
      text-align: left;
      font-size: 0.25rem;
      color: rgba(0, 0, 0, 0.45);
    }
    .container__dialog__button {
      width: 100%;
      .container__dialog__button__confirm {
        height: 0.7rem;
        width: 5rem;
        display: block;
        margin: 0 auto;
        margin-top: 0.3rem;
        line-height: 0.7rem;
        font-size: 0.3rem;
      }
      .container__dialog__button__signout {
        height: 0.7rem;
        width: 5rem;
        display: block;
        margin: 0 auto;
        margin-top: 0.3rem;
        line-height: 0.7rem;
        font-size: 0.3rem;
        .van-button__text {
          font-family: PingFang SC;
          color: #000;
        }
      }
    }
  }
  .button {
    width: 4rem;
    height: 0.8rem;
    margin-top: 4rem;
    line-height: 0.8rem;
    font-family: PingFang SC;
    font-size: 0.27rem;
  }
  /deep/ .van-dialog__confirm,
  .van-dialog__confirm:active {
    display: none;
  }
  /deep/ .van-dialog__footer--buttons .van-button {
    display: none;
  }
  /deep/ .van-dialog__header {
    padding: 0.25rem;
    padding-left: 2em;
    text-align: left;
    font-size: 0.32rem;
    font-weight: bold;
    border-bottom: 1px solid rgba(0, 0, 0, 0.14901960784313725);
  }
}
</style>